
import "./styles.scss";
const Footer = props => {
    return(
        <div className="footer">
            <div className="wrap">
                <h3>
                    @Sabra2024
                </h3>
            </div>
        </div>
    );
}


export default Footer;